module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper"
  }, [(_vm.detailData.courseImg !== undefined) ? _c('img', {
    staticClass: "bigImg",
    attrs: {
      "src": _vm.detailData.courseImg,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "bigImg",
    attrs: {
      "src": require("../../../../static/image/default.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtCont"
  }, [_c('div', {
    staticClass: "firstLine"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.detailData.subject))]), _vm._v(" "), (_vm.detailData.courseState === '2') ? _c('el-tag', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "color": "#00abad"
    }
  }, [_vm._v("未开始")]) : _vm._e(), _vm._v(" "), (_vm.detailData.courseState === '3') ? _c('el-tag', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "color": "#f0a800"
    }
  }, [_vm._v("进行中")]) : _vm._e(), _vm._v(" "), (_vm.detailData.courseState === '4') ? _c('el-tag', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("已结束")]) : _vm._e(), _vm._v(" "), (_vm.keyList.length !== 0) ? _c('div', {
    staticClass: "spanKeys"
  }, _vm._l((_vm.keyList), function(key, index) {
    return _c('div', {
      key: index,
      staticClass: "spanKey1"
    }, [_c('div', {
      staticClass: "spanKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._m(0, true)])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "secLine"
  }, [_c('span', {
    staticClass: "iconfont icon-chakan"
  }), _c('i', [_vm._v("观看" + _vm._s(_vm.detailData.lookNum))]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-pingjia"
  }), _c('i', [_vm._v("评价" + _vm._s(_vm.detailData.evaluateNum))]), _vm._v(" "), (_vm.detailData.appreciateFlag === '0') ? _c('span', {
    staticClass: "iconfont icon-dianzan"
  }) : _c('span', {
    staticClass: "iconfont icon-yidianzan"
  }), _vm._v(" "), _c('i', [_vm._v("点赞" + _vm._s(_vm.detailData.goodNum))]), _vm._v(" "), (_vm.detailData.collectFlag === '0') ? _c('span', {
    staticClass: "iconfont icon-shoucang"
  }) : _c('span', {
    staticClass: "iconfont icon-yishoucang"
  }), _vm._v(" "), _c('i', [_vm._v("收藏" + _vm._s(_vm.detailData.collectNum))])]), _vm._v(" "), _c('div', {
    staticClass: "thirdLine"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("授课人 : ")]), _vm._v(" "), _c('div', {
    staticClass: "subStant"
  }, [_vm._v(_vm._s(_vm.detailData.teacherName))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("课程时间 : ")]), _vm._v(" "), (_vm.detailData.teachType === '1') ? _c('div', {
    staticClass: "subStant"
  }, [_vm._v(_vm._s(_vm.detailData.courseTimeStr))]) : _vm._e(), _vm._v(" "), (_vm.detailData.teachType === '2') ? _c('div', {
    staticClass: "subStant"
  }, [_vm._v("永久")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("课程分类 : ")]), _vm._v(" "), _c('div', {
    staticClass: "subStant"
  }, [_vm._v(_vm._s(_vm.courseDesc))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("学科分类 : ")]), _vm._v(" "), _c('div', {
    staticClass: "subStant"
  }, [_vm._v(_vm._s(_vm.scienceDesc))])]), _vm._v(" "), _c('li', {
    staticClass: "lastLine"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("课程简介 : ")]), _vm._v(" "), _c('div', {
    staticClass: "subStant subBrief",
    attrs: {
      "title": _vm.detailData.remark
    }
  }, [_vm._v(_vm._s(_vm.changeRemark))])])])]), _vm._v(" "), (this.$route.name != 'LookCourse') ? _c('div', {
    staticStyle: {
      "margin-top": "-4px"
    }
  }, [_c('div', {
    staticClass: "startLearn",
    class: _vm.starts ? '' : 'unable',
    on: {
      "click": _vm.startLearn
    }
  }, [_vm._v("开始学习")]), _vm._v(" "), _c('div', {
    staticClass: "startLearn startCollect",
    on: {
      "click": _vm.switCollect
    }
  }, [_vm._v(_vm._s(_vm.collect))])]) : _c('div', [_c('div', {
    staticClass: "startLearn",
    class: _vm.starts ? '' : 'unable',
    on: {
      "click": _vm.startLearn
    }
  }, [_vm._v("进入课程")])]), _vm._v(" "), (_vm.xiajiaIcon) ? _c('div', {
    staticClass: "lower iconfont icon-yixiajia"
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('span', {
    staticClass: "arrow_1"
  }, [_vm._v("。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-29898d90","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upper/upper.vue
// module id = 543
// module chunks = 1 2 3 4 5 6 7 8